import axios from 'axios'
import router from 'vue-router'
import {
  auth
} from "./auth";

/**
 * 定义请求常量
 * TIME_OUT、ERR_OK
 */
export const TIME_OUT = 5000; // 请求超时时间
export const ERR_OK = true; // 请求成功返回状态，字段和后台统一
// export const baseUrl = process.env.BASE_URL   // 引入全局url，定义在全局变量process.env中，开发环境为了方便转发，值为空字符串

// 环境的切换
let baseURL = process.env.NODE_ENV == 'production' ? 'https://acc.tuotuoexing.com/new_x' : `https://acc.tuotuoexing.com/new_x`

// create an axios instance
export const service = axios.create({
  baseURL: config.BASE_API || process.env.VUE_APP_BASE_API,
  //  process.env.VUE_APP_BASE_API :这种方式在config/dev.env.js或者prod.dev.env.js中配置VUE_APP_BASE_API 
  timeout: TIME_OUT, // 请求超时时间
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "content-Type": "application/json; charset=UTF-8",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
  },
});
service.defaults.baseURL = baseURL;

// 封装请求拦截
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    config.headers['accessToken'] = '';

    const token = auth.getToken();
    if (token) {
      config.headers["Authorization"] = token;
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 封装响应拦截，判断token是否过期
service.interceptors.response.use(
  response => {
    const res = response.data;

    if (res.code === 200) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(new Error(res.msg || "Error"));
    }

  },
  error => {
    // return Promise.reject(error.response)
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。                
        case 401:
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath // 401后跳转登录页  把当前路由带上 登录后可直接回到该路由
            }
          });
          break;
          // 403 token过期
          // 登录过期对用户进行提示
          // 清除本地token和清空vuex中token对象
          // 跳转登录页面                
        case 403:
          // var toast = Toast.$create({
          //     txt: '登录过期，请重新登录',
          //     mask: true
          // })
          // toast.show()
          // 清除token
          localStorage.removeItem('token');
          store.commit('loginSuccess', null);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面 
          setTimeout(() => {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;

          // 404请求不存在
        case 404:
          // var toast = Toast.$create({
          //     txt: '网络请求不存在',
          //     mask: true
          // })
          // toast.show()
          break;

          // 其他错误，直接抛出错误提示
        default:
          // var toast = Toast.$create({
          //     txt: error.response.data.message,
          //     mask: true
          // })
          // toast.show()
      }
    }
    return Promise.reject(error.response)
  }
)

export default service;



// WEBPACK FOOTER //
// ./src/http/request.js